import React, { useEffect } from "react";
import { ConfirmContainer } from "./style";
import Button from "../button";
import makeSafe from "../../lib/makeSafeToUseInDangerousInnerHtml";

/**
 * Confirm pop up.
 * @param {object} content
 * content={
 *    type: 'success || warning || danger || info',
 *    icon: 'ICON_NAME',
 *    title: 'modal title',
 *    message: 'modal message',
 *    comment: 'a comment that show in bottom of message',
 *    acceptButtonText: 'BUTTON_TEXT',
 *    rejectButtonText: 'BUTTON_TEXT'
 * onChange true , false
 *  }
 * @param {function} acceptHandler
 * @param {function} rejectHandler
 * @param {function} close
 * @param {boolean} show
 */
export const Confirm = props => {
  useEffect(() => {
    if (props.show) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [props.show]);
  return (
    <ConfirmContainer
      type={props.content.type}
      show={props.show}
      showUnderOtherConfirms={props.showUnderOtherConfirms}
    >
      <div
        className="overlay"
        onClick={
          props.loading || !props.close ? () => false : () => props.close()
        }
      />
      <div className="confirm-box">
        <div className="confirm-header">
          <i
            className={`confirm-icon icon ${props.content.icon ||
              "icon mapsa-notification"}`}
          />
        </div>
        <div className="confirm-body">
          <div className="title">{props.content.title}</div>
          <div
            className="message"
            dangerouslySetInnerHTML={{
              __html: props.content.message
                ? makeSafe(props.content.message.split("\n").join("<br/>"))
                : props.content.message
            }}
          />
          <small>{props.content.comment}</small>
        </div>
        <div className="confirm-footer">
          {props.content.acceptButtonText && props.acceptHandler !== undefined && (
            <Button
              type="button"
              btn={"outline"}
              borderless={"borderLess"}
              onClick={e => {
                e.preventDefault();
                props.acceptHandler();
              }}
              loading={props.loading}
            >
              {props.content.acceptButtonText}
            </Button>
          )}
          {props.content.rejectButtonText && props.rejectHandler !== undefined && (
            <Button
              disabled={props.loading ? 1 : 0}
              type="button"
              btn={"outline"}
              borderless={"borderLess"}
              onClick={e => {
                e.preventDefault();
                props.rejectHandler();
              }}
            >
              {props.content.rejectButtonText}
            </Button>
          )}
        </div>
      </div>
    </ConfirmContainer>
  );
};
